import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {CorporationsListComponent} from './corporations-list/corporations-list.component';
import {NotificationsModalComponent} from './notifications-modal/notifications-modal.component';
import {SettingsEmailMergeComponent} from './settings-email-merge.component';
import {SettingsEmailMergeDetailedViewComponent} from './settings-email-merge-detailed-view/settings-email-merge-detailed-view.component';
import {SettingsEmailMergeService} from '../../services/settings-email-merge.service';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule,
        UtilsModule
    ],
    declarations: [
        SettingsEmailMergeDetailedViewComponent,
        SettingsEmailMergeComponent,
        CorporationsListComponent,
        NotificationsModalComponent
    ],
    providers: [
        SettingsEmailMergeService
    ]
})
export class SettingsEmailMergeModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/settings-email-merge.module.ts